import { VERTICAL_EMBED_TYPE } from "./../../ricos-content";
import { changeBaseUrl } from "./changeBaseUrl";
function verticalEmbedViewerStrategy(baseUrl, disabled = false) {
  return {
    config: {
      [VERTICAL_EMBED_TYPE]: {
        changeBaseUrl: (url) => changeBaseUrl(url, baseUrl),
        disabled
      }
    }
  };
}
export {
  verticalEmbedViewerStrategy
};
//# sourceMappingURL=verticalEmbedViewerStrategy.js.map
